import { Table } from 'react-bootstrap';
import LeadsTableBody from './LeadsTableBody';
import { useTranslation } from 'react-i18next';
import TableHeadTdOrder from 'components/others/TableHeadTdOrder';
import { useLead } from './context/LeadProvider';
import SpinnerBlock from 'components/others/SpinnerBlock';
import type { LeadsTableProps } from './types';

const LeadsTable = ({ leadsList, fetchLeads, setClientInfoId, setTasksLeadId }: LeadsTableProps) => {
    const { t } = useTranslation(['Leads']);
    const { showSpinner, leadsOrder, setLeadsOrder, leadsDesc, setLeadsDesc } = useLead();

    const handleOrderClick = (value: string, desc: boolean) => {
        setLeadsOrder(value);
        setLeadsDesc(desc);
    };

    return (
        <>
            <SpinnerBlock onlyBlur={true} show={showSpinner} />

            <div className="crm-table-wrap">
                <Table className="LeadTable table-hover">
                    <thead>
                        <tr className="bg-light">
                            <td className="head-name">
                                <TableHeadTdOrder
                                    title={t('fields.name')}
                                    onClick={handleOrderClick}
                                    value={leadsOrder}
                                    desc={leadsDesc}
                                    fieldName="client_name"
                                />
                            </td>
                            <td className="head-source">
                                {t('fields.source')}
                            </td>
                            <td className="head-status">
                                <TableHeadTdOrder
                                    title={t('fields.status')}
                                    onClick={handleOrderClick}
                                    value={leadsOrder}
                                    desc={leadsDesc}
                                    fieldName="lead_status"
                                />
                            </td>
                            <td className="head-updated">
                                <TableHeadTdOrder
                                    title={t('fields.update')}
                                    onClick={handleOrderClick}
                                    value={leadsOrder}
                                    desc={leadsDesc}
                                    fieldName="lead_created"
                                />
                            </td>
                            <td className="head-action">{t('fields.action')}</td>
                        </tr>
                    </thead>

                    <LeadsTableBody
                        setClientInfoId={setClientInfoId}
                        setTasksLeadId={setTasksLeadId}
                        leadsList={leadsList}
                        fetchLeads={fetchLeads}
                    />
                </Table>
            </div>
        </>
    );
};

export default LeadsTable;
